import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { compose, withState, withProps, withHandlers } from 'recompose';
import Modal from '../../../common/Modal';
import DatePicker from '../../../common/DatePicker';
import withTimezone from '../../../auth/utils/withTimezone';

const InvoiceChangeDueDateModal = ({
  close,
  confirm,
  formDisabled,
  dueDate,
  date,
  onDateChanged,
 }) => (
   <Modal title="Change Due Date" close={close} showCloseButton>
     <div className="u-text-right u-m">
       <div className="u-mb">
         <DatePicker
           startDate={dueDate}
           onChange={onDateChanged}
           value={date}
           type="text"
           defaultValue={null}
         />
       </div>
       <button
         type="button"
         className="c-btn c-btn--grey u-width-120 u-mr"
         onClick={close}
       >
        Cancel
      </button>
       <button
         type="button"
         className="c-btn u-width-120"
         onClick={confirm}
         disabled={formDisabled}
       >
        Confirm
      </button>
     </div>
   </Modal>
);

InvoiceChangeDueDateModal.propTypes = {
  close: PropTypes.func.isRequired,
  confirm: PropTypes.func.isRequired,
  date: PropTypes.instanceOf(Date).isRequired,
  onDateChanged: PropTypes.func.isRequired,
  dueDate: PropTypes.instanceOf(Date).isRequired,
  formDisabled: PropTypes.bool.isRequired,
};

const enhance = compose(
  withTimezone,
  withProps(props => ({
    dueDate: moment.tz(props.dueDate, props.timezone).toDate(),
  })),
  withState('date', 'setDate', props => props.dueDate),
  withHandlers({
    confirm: props => () => {
      props.onSubmit(props.date);
    },
    onDateChanged: props => (value) => {
      props.setDate(moment.tz(value, props.timezone).toDate());
    },
  }),
  withProps(props => ({
    formDisabled: moment(props.date).isSame(props.dueDate, 'day'),
  })),
);

export default enhance(InvoiceChangeDueDateModal);
